export default "__VITE_ASSET__CHvizzFE__";